export const ACCEPTED_TYPES = ["application/pdf"];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

/**
 * Why a file was rejected, as a code rather than a sentence.
 *
 * This helper is shared by a localized surface (/join sources) and an
 * un-localized one (settings resume). Returning prose forced the English
 * sentence onto both, which is how a Portuguese toast ended up with an English
 * description under a translated title. The caller owns the wording, so each
 * one can reach for its catalog or its own literal.
 */
export type ResumeFileProblem = "wrong-type" | "too-large";

export function validateFile(file: File): ResumeFileProblem | null {
  if (!ACCEPTED_TYPES.includes(file.type)) {
    return "wrong-type";
  }
  if (file.size > MAX_FILE_SIZE) {
    return "too-large";
  }
  return null;
}
